import React, { Component } from 'react';
import { Link } from "react-router-dom";

//Import images
import errorImg from "../../assets/images/error-img.png";
import { Grid } from '@mui/material';

import './Error404.scss';

class Error404 extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="error-container">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                           <div className="error-content">
                                    <h1 className="fw-bold text-error">4 <span className="error-text">0<img src={errorImg} alt="" className="error-img" /></span> 4</h1>
                                    <h3 className="text-uppercase">Sorry, page not found</h3>
                                    <div className="error-content__button">
                                        <Link to="/" className="btn btn-primary waves-effect waves-light" >Back to Dashboard</Link>
                                    </div>
                                </div> 
                        </Grid>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
}

export default Error404;